/* eslint-disable no-underscore-dangle */
import { useDispatch } from "react-redux";
import { find, isArray, trim } from "lodash";

import TextComboInput from "@shared/v2/TextComboInput";

import { defaultLink } from "../../ModalViews/styles";
import { setPersonValue } from "../../../reducers/contactsReducer";
import { useContactPerson } from "../../../reducers/contactsReducer/selectors";

const DefaultLinks = () => {
  const dispatch = useDispatch();
  const person = useContactPerson();

  const findReviewLinkValue = (name) => {
    const link = isArray(person.reviewLinksAttributes)
      ? person.reviewLinksAttributes.find((l) => l.name === name && !l._destroy)
      : null;
    return link?.value || "";
  };

  const onChangeHandler = (value, name) => {
    let reviewLinks = isArray(person.reviewLinksAttributes) ? [...person.reviewLinksAttributes] : [];
    const existing = find(reviewLinks, { name });

    if (trim(value) !== "") {
      if (existing) {
        reviewLinks = reviewLinks.map((link) =>
          link.name === name
            ? {
                ...link,
                category: "review_link",
                position: null,
                meta: null,
                value,
                name,
                _destroy: false,
              }
            : link,
        );
      } else {
        reviewLinks.push({
          category: "review_link",
          position: null,
          meta: null,
          value,
          name,
        });
      }
    } else if (existing?.id) {
      // Mark persisted records for destruction so backend removes them
      reviewLinks = reviewLinks.map((link) =>
        link.name === name ? { ...link, value: "", _destroy: true } : link,
      );
    } else {
      // For new/unsaved records, remove entirely
      reviewLinks = reviewLinks.filter((link) => link.name !== name);
    }

    dispatch(setPersonValue({ key: "reviewLinksAttributes", value: reviewLinks }));
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-[24px]">
      <div className="tw-flex tw-justify-between">
        <TextComboInput
          value={findReviewLinkValue("zillow_reviews")}
          containerClassName={defaultLink}
          label="Zillow"
          onChange={(e) => onChangeHandler(e.target.value, "zillow_reviews")}
        />
        <TextComboInput
          value={findReviewLinkValue("google_reviews")}
          containerClassName={defaultLink}
          label="Google"
          onChange={(e) => onChangeHandler(e.target.value, "google_reviews")}
        />
      </div>
      <div className="tw-flex tw-justify-between">
        <TextComboInput
          value={findReviewLinkValue("facebook_reviews")}
          containerClassName={defaultLink}
          label="Facebook"
          onChange={(e) => onChangeHandler(e.target.value, "facebook_reviews")}
        />
        <TextComboInput
          value={findReviewLinkValue("realtor_com_reviews")}
          containerClassName={defaultLink}
          label="Realtor.com"
          onChange={(e) => onChangeHandler(e.target.value, "realtor_com_reviews")}
        />
      </div>
      <div className="tw-flex tw-justify-between">
        <TextComboInput
          value={findReviewLinkValue("yelp_reviews")}
          containerClassName={defaultLink}
          label="Yelp"
          onChange={(e) => onChangeHandler(e.target.value, "yelp_reviews")}
        />
        <TextComboInput
          value={findReviewLinkValue("trulia_reviews")}
          containerClassName={defaultLink}
          label="Trulia"
          onChange={(e) => onChangeHandler(e.target.value, "trulia_reviews")}
        />
      </div>
    </div>
  );
};

export default DefaultLinks;
